var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { staticClass: "zalog-leasing", attrs: { link: "zalog" } },
    [
      _c(
        "div",
        {
          staticClass: "zalog-leasing__header",
          attrs: { slot: "tileHeader" },
          slot: "tileHeader",
        },
        [
          _c("tile-title", { attrs: { icon: "none" } }, [
            _c("span", [
              _c("i", { staticClass: "fas fa-lock" }),
              _vm._v(" Лизинг / Залоги"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "app-switcher",
            {
              attrs: {
                leftClickHandler: _vm.toggle,
                rightClickHandler: _vm.toggle,
              },
            },
            [
              _c("span", { attrs: { slot: "leftValue" }, slot: "leftValue" }, [
                _vm._v("Лизинг"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { attrs: { slot: "rightValue" }, slot: "rightValue" },
                [_vm._v("Залоги")]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "zalog-leasing__content",
          attrs: { slot: "tileContent" },
          slot: "tileContent",
        },
        [
          _vm.type === "leasing"
            ? _c("leasing", {
                ref: "leasingRef",
                attrs: { list: _vm.leasingList },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "zalog"
            ? _c("zalog", { ref: "zalogRef", attrs: { list: _vm.zalogList } })
            : _vm._e(),
          _vm._v(" "),
          _c("leasing-modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLeasingModal,
                expression: "isLeasingModal",
              },
            ],
            ref: "leasingModal",
            attrs: {
              list: _vm.leasingList,
              printStyle: _vm.printStyle,
              title: _vm.title,
            },
            on: { close: _vm.closeLeasingModal },
          }),
          _vm._v(" "),
          _c("zalog-modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isZalogModal,
                expression: "isZalogModal",
              },
            ],
            ref: "zalogModal",
            attrs: {
              list: _vm.zalogList,
              pagination: _vm.zalogPagination,
              printStyle: _vm.printStyle,
              title: _vm.title,
            },
            on: { close: _vm.closeZalogModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "zalog-leasing__footer",
          class: {
            "flex-end":
              (!_vm.isLeasingBtn && _vm.type === "leasing") ||
              (!_vm.isZalogBtn && _vm.type === "zalog"),
          },
          attrs: { slot: "tileFooter" },
          slot: "tileFooter",
        },
        [
          _vm.isLeasingBtn
            ? _c(
                "tile-button",
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.openLeasingModal.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Все сообщения")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isZalogBtn
            ? _c(
                "tile-button",
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.openZalogModal.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "Все уведомления (" + _vm._s(_vm.zalogTotalCount) + ")"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("tilePrintPdf", {
            attrs: {
              html: _vm.htmlContent,
              title: _vm.title,
              filename: _vm.filename,
              printStyle: _vm.printStyle,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }